const sessionClassifierBuilder = function(
    sessionTypeClassifier, sessionContentsClassifier, sessionRulesClassifier, customClassifier
){
    if (sessionTypeClassifier && typeof(sessionTypeClassifier) !== 'function') {
        throw new TypeError('sessionTypeClassifier must be passed as undefined or function');
    }
    if (sessionContentsClassifier && typeof(sessionContentsClassifier) !== 'function') {
        throw new TypeError('sessionContentsClassifier must be passed as undefined or function');
    }
    if (sessionRulesClassifier && typeof(sessionRulesClassifier) !== 'function') {
        throw new TypeError('sessionRulesClassifier must be passed as undefined or function');
    }
    if (customClassifier && typeof(customClassifier) !== 'function') {
        throw new TypeError('customClassifier must be passed as undefined or function');
    }

    return function(session) {
        if (sessionTypeClassifier && !sessionTypeClassifier(session.sessionType)) {
            return false;
        }
        if (sessionContentsClassifier && !sessionContentsClassifier(
            session.parameters.SessionContents || session.parameters.SessionSchema, session.parameters.SessionSchemaRef
        )) {
            return false;
        }
        if (sessionRulesClassifier && !sessionRulesClassifier(session.rules)) {
            return false;
        }
        if (customClassifier && !customClassifier(session)) {
            return false;
        }

        return true;
    }
}

export default sessionClassifierBuilder;